import { Upsell } from './Upsell';

export class UpsellGroup {
    items: Array<Upsell>;
    title: string;
    type: string;

    constructor(init?: Partial<UpsellGroup>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): UpsellGroup {
        const upsellGroup = new UpsellGroup();
        Object.assign(upsellGroup, obj);
        return upsellGroup;
    }
}
